import { render } from "./CommentForm.vue?vue&type=template&id=03132896&scoped=true"
import script from "./CommentForm.vue?vue&type=script&lang=js"
export * from "./CommentForm.vue?vue&type=script&lang=js"

import "./CommentForm.vue?vue&type=style&index=0&id=03132896&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-03132896"

export default script